//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    display() {
      return !!this.callToAction?.title;
    },
    isBr() {
      return this.$nuxt.$config.COUNTRY === 'br';
    },
    isCo() {
      return this.$nuxt.$config.COUNTRY === 'co';
    },
    event() {
      return this.$store.state.event.data;
    },
    topic() {
      return this.$store.state.event.topic;
    },
    callToAction() {
      const callToActions = this.topic.callToActions || [];
      return callToActions[0] || {};
    },
    discounts() {
      const discounts = this.topic.nomenclatureDiscounts;
      return discounts || [];
    },
    discountPercent() {
      return this.discounts[0]?.priceTypePercent || 0;
    },
    discountPrice() {
      return this.formatNumber(this.discounts[0].price) || 0;
    },
    discountInt() {
      return this.discounts[0]?.discount;
    },
    eventStatus() {
      return this.$store.state.event.eventStatus;
    },
    topicStatus() {
      return this.$store.getters['event/topicStatus'];
    },
  },
  methods: {
    formatNumber(value) {
      return parseFloat(value).toLocaleString(
        this.$app.config.current.localeName,
        { minimumFractionDigits: 0, maximumFractionDigits: 0 },
      );
    },
    sendGtm() {
      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'webinar_click',
        eventAction: 'buy_course',
        eventLabel: this.event?.name,
      });
    },
  },
};
